








import Vue from 'vue'
import { Notification as NotificationType } from '@/core/Notifications'
import Notification from './Notification.vue'

export default Vue.extend({
  name: 'Notifications',
  components: {
    Notification,
  },
  props: {
    notifications: {
      type: Array as () => NotificationType[],
      default: [],
    },
  },
})
